import { RedirectionVisitor } from "./RedirectionVisitor";
/**
 *
 */
export class ContentRedirectionVisitor extends RedirectionVisitor {
    constructor(value) {
        super(value);
    }
}
